import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "px-2 py-4 flex flex-col items-center justify-center"
};
const _hoisted_2 = {
  class: "mb-4"
};
import { GameSlot } from "@/modules/main-menu/entity";
import { app } from "@/di";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import GameSlotComponent from "@/modules/main-menu/components/GameSlot.vue";
import GameSaver from "@/modules/main-menu/services/GameSaver";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Update',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const slots = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      slots.value = await GameSlot.createQueryBuilder('slot').getMany();
    })), __temp = await __temp, __restore(), __temp);
    const {
      doLoading
    } = useLoading();
    const message = useMessage();
    const dialog = ref(null);
    const override = async gameSlot => {
      if (gameSlot) {
        await dialog.value?.confirm();
      }
      await doLoading(async () => {
        await app.get(GameSaver).save({
          gameSlot
        });
        message.success(translator.t('done'));
        await refresh();
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      const _component_NEmpty = _resolveComponent("NEmpty");
      return _openBlock(), _createBlock(DefaultInGameLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('save_game')), 1)]),
        default: _withCtx(() => [_createVNode(RichDialog, {
          ref_key: "dialog",
          ref: dialog,
          "confirmation-only": _ctx.$t('sure_you_want_to_override_it?')
        }, null, 8, ["confirmation-only"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_NButton, {
          type: "success",
          secondary: "",
          onClick: _cache[0] || (_cache[0] = () => override())
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('save_to_new_slot')), 1)]),
          _: 1
        })]), slots.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_saved_games_yet')
        }, null, 8, ["description"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slots.value, slot => {
          return _openBlock(), _createBlock(GameSlotComponent, {
            key: slot.id,
            "game-slot": slot,
            onDeleted: _unref(refresh)
          }, {
            cta: _withCtx(() => [_createVNode(_component_NButton, {
              type: "success",
              secondary: "",
              onClick: $event => override(slot)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('override')), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1032, ["game-slot", "onDeleted"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});